export default "__VITE_ASSET__BMDVQQrR__"